import config from '../../config.js'
// export const CLIENT_KEY: string = "ycW3AqQAzRN9FLGrEBdxQuhewR8b6v2V";
// export const CLIENT_SECRET: string =
//   "6ZbKfeRAuj3j2UBDxuyBLD3Gjzvh7NRZHZHNPjKSLVazvpNg";
// export const BASE_URL: string = "https://lj-test-v2.api.strix.com.ar";

export const CLIENT_KEY: string = config.api_username();
export const CLIENT_SECRET: string =config.api_password();
export const BASE_URL: string = config.apiHttpUrl();